/**
=========================================================
* Material Kit 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/**
 * The base breakpoints for the Material Kit 2 PRO React.
 * You can add new breakpoints using this file.
 * You can customized the breakpoints for the entire Material Kit 2 PRO React using thie file.
 */

const breakpoints = {
  values: {
    xs: 0,
    isMobile: 425,
    sm: 576,
    md: 768,
    lg: 992,
    heroFont: 1024,
    xl: 1200,
    navMenu: 1248,

    xxl: 1400,
  },
};
export default breakpoints;
